import { render, staticRenderFns } from "./index.vue?vue&type=template&id=68a8807c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=68a8807c&prod&lang=less&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=68a8807c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_9104b087796de0a589f26e8ae34b49bc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a8807c",
  null
  
)

export default component.exports